module.exports = __webpack_public_path__ + "static/media/logo.eb7fb6da.png";